module.exports = __webpack_public_path__ + "img/font_logo.70b10bc0.png";